<script lang="ts">

import {Spinner} from "flowbite-svelte";
import {goto} from "$app/navigation";
import {user, token} from "$lib/stores/auth";
import {onMount} from "svelte";

onMount(() => {
    setTimeout(async () => {
        localStorage.clear();
        sessionStorage.clear();
        user.set(undefined);
        token.set(undefined);
        await goto('/');
    }, 800)
})

</script>
<Spinner/>